import {type Localization} from '../Hooks/useLocalization'
import {
    type Certificate,
    type CertificateCalculatedStatus,
    certificateStatusesExpired,
    certificateStatusesNotValidYet,
    type CompanyBranch,
} from '../Store/DataSlice'

export function formatCompanyBranch(
    branch: CompanyBranch,
    countryLocalization: Localization
) {
    let formatted =
        branch.name != null
            ? `${branch.name} (${branch.number}) `
            : `${branch.number} `
    if (branch.addressLine1) formatted += `${branch.addressLine1}, `
    if (branch.postalCode || branch.city)
        formatted += `${branch.postalCode} ${branch.city}, `
    if (branch.countryCode)
        formatted += countryLocalization.text(
            branch.countryCode,
            branch.countryCode
        )
    return formatted
}

// also copy to src\Orchestration\WebworkerFunctions.ts for webworker optimalization
export function calculateCertificateActualStatus(
    certificate: Certificate | undefined
): CertificateCalculatedStatus {
    const dateNow = Date.now()
    if (certificate === undefined) return ''
    if (certificate.status !== 'Valid' && certificate.status !== 'Prolonged')
        return certificate.status
    if (certificate.validFrom >= dateNow) {
        return certificateStatusesNotValidYet
    }
    if (
        certificate.validFrom <= dateNow &&
        (certificate.status === 'Prolonged' &&
        certificate.extendedUntil !== undefined
            ? certificate.extendedUntil
            : certificate.validUntil) >= dateNow
    )
        return certificate.status
    return certificateStatusesExpired
}

export function toBelgianDate(date: Date | number | undefined) {
    if (date == null) {
        return '';
    }

    return (typeof date === 'number' ? new Date(date) : date).toLocaleDateString('nl-BE', { year: 'numeric', month: '2-digit', day: '2-digit' });
    
}

export function getKboUrl(vatNumber: string) {
    const numberOnly = vatNumber.toLowerCase().replace('be', '')
    return `https://kbopub.economie.fgov.be/kbopub/zoeknummerform.html?nummer=${numberOnly}&actionLu=Zoek`
}
